"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';

var getIteratorFn = function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  return typeof iteratorFn === 'function' ? iteratorFn : null;
};

var isReactNode = function isReactNode(propValue) {
  switch (typeof propValue) {
    case 'number':
    case 'string':
    case 'undefined':
      return true;

    case 'boolean':
      return !propValue;

    case 'object':
      if (Array.isArray(propValue)) {
        return propValue.every(isReactNode);
      }

      if (propValue === null || React.isValidElement(propValue)) {
        return true;
      }

      var iteratorFn = getIteratorFn(propValue);

      if (iteratorFn) {
        var iterator = iteratorFn.call(propValue);
        var step;

        if (iteratorFn !== propValue.entries) {
          while (!(step = iterator.next()).done) {
            if (!isReactNode(step.value)) {
              return false;
            }
          }
        } else {
          while (!(step = iterator.next()).done) {
            var entry = step.value;

            if (entry) {
              if (!isReactNode(entry[1])) {
                return false;
              }
            }
          }
        }
      } else {
        return false;
      }

      return true;

    default:
      return false;
  }
};

var _default = isReactNode;
exports.default = _default;